<template>
  <div class="imageUploadContainer">
    <div class="imageUploadList">
      <div v-for="(path, index) in imageListData" v-bind:key="index" class="imageItem">
        <img
          :src="outImageFullPath(path)"
          class="img"
          :class="{ dragging: isDragging(index) }"
          :draggable="true"
          :data-index="index"
          @click="previewImage"
          @touchstart="start"
          @touchmove.stop.prevent="move"
          @touchend="stop"
        />
        <div v-if="isShowDel" class="imageDel" :data-index="index" @click="deleteImage">x</div>
      </div>
      <div v-if="isShowAdd" class="imageUpload" @click="selectImage">+</div>
    </div>
    <img
      v-if="showMoveImage"
      class="moveImage"
      :style="{ left: posMoveImageLeft, top: posMoveImageTop }"
      :src="moveImagePath"
    />
  </div>
</template>

<script>
import { outImageFullPath } from '@/views/funcPuzzle/utils/util.js'
export default {
  name: 'uni-image-upload',
  /*
  props: [
    'value',
    'enableDel',
    'enableAdd',
    'enableDrag',
    'serverUrl',
    'formData',
    'header',
    'limit',
    'fileKeyName',
    'showUploadProgress',
    'serverUrlDeleteImage'
  ],
  */
  props: {
    modelValue: {
      type: Array,
      default: () => {
        return []
      }
    },
    enableDel: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    addLink: {
      // 跳转页面添加还是直接添加图片
      type: Boolean,
      default: false
    },
    enableAdd: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    enableDrag: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    showUploadProgress: {
      type: Boolean,
      default: true
    },
    serverUrl: {
      type: String,
      default: ''
    },
    serverUrlDeleteImage: {
      type: String,
      default: ''
    },
    formData: {
      type: [String, Object],
      default: ''
    },
    header: {
      type: [String, Object],
      default: () => {
        return { 'Content-Type': 'multipart/form-data' }
      }
    },
    fileKeyName: {
      type: String,
      default: ''
    },
    resultFileName: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      imageBasePos: {
        x0: -1,
        y0: -1,
        w: -1,
        h: -1
      },
      showMoveImage: false,
      moveImagePath: '',
      moveLeft: 0,
      moveTop: 0,
      deltaLeft: 0,
      deltaTop: 0,
      dragIndex: null,
      targetImageIndex: null,
      imageList: [],
      isDestroyed: false
    }
  },
  mounted: function () {
    this.imageList = this.modelValue

    // if (this.showUploadProgress === false) {
    //   this.showUploadProgress = false
    // } else {
    // this.showUploadProgress = true
    // }
  },
  destroyed: function () {
    this.isDestroyed = true
  },
  computed: {
    imageListData: function () {
      this.imageList = this.modelValue
      if (this.modelValue) {
        return this.modelValue
      }
    },
    posMoveImageLeft: function () {
      return this.moveLeft + 'px'
    },
    posMoveImageTop: function () {
      return this.moveTop + 'px'
    },
    isShowDel: function () {
      if (this.enableDel === false) {
        return false
      } else {
        return true
      }
    },
    isShowAdd: function () {
      if (this.enableAdd === false) {
        return false
      }
      if (this.limit && this.imageList.length >= this.limit) {
        return false
      }

      return true
    },
    isDragable: function () {
      if (this.enableDrag === false) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    outImageFullPath,
    selectImage: function () {
      if (this.addLink) {
        this.$emit('addLink')
        return
      }
      var _self = this
      if (!_self.imageList) {
        _self.imageList = []
      }

      uni.chooseImage({
        count: _self.limit ? _self.limit - _self.imageList.length : 999,
        success: function (e) {
          var imagePathArr = e.tempFilePaths

          //如果设置了limit限制，在web上count参数无效，这里做判断控制选择的数量是否合要求
          //在非微信小程序里，虽然可以选多张，但选择的结果会被截掉
          //在app里，会自动做选择数量的限制
          if (_self.limit) {
            var availableImageNumber = _self.limit - _self.imageList.length
            if (availableImageNumber < imagePathArr.length) {
              uni.showToast({
                title:
                  '图片总数限制为' + _self.limit + '张，当前还可以选' + availableImageNumber + '张',
                icon: 'none',
                mask: false,
                duration: 2000
              })
              return
            }
          }

          //检查服务器地址是否设置，设置即表示图片要上传到服务器
          if (_self.serverUrl) {
            uni.showToast({
              title: '上传进度：0/' + imagePathArr.length,
              icon: 'none',
              mask: false
            })

            var remoteIndexStart = _self.imageList.length - imagePathArr.length
            var promiseWorkList = []
            var keyname = _self.fileKeyName ? _self.fileKeyName : 'upload-images'
            var completeImages = 0

            for (let i = 0; i < imagePathArr.length; i++) {
              promiseWorkList.push(
                new Promise((resolve, reject) => {
                  const remoteUrlIndex = remoteIndexStart + i
                  uni.uploadFile({
                    url: _self.serverUrl,
                    fileType: 'image',
                    header: _self.header,
                    formData: _self.formData,
                    filePath: imagePathArr[i],
                    name: keyname,
                    success: function (res) {
                      if (res.statusCode === 200) {
                        if (_self.isDestroyed) {
                          return
                        }

                        completeImages++

                        if (_self.showUploadProgress) {
                          uni.showToast({
                            title: '上传进度：' + completeImages + '/' + imagePathArr.length,
                            icon: 'none',
                            mask: false,
                            duration: 500
                          })
                        }
                        // let resData = _self.resultFileName
                        //   ? JSON.parse(res.data)[_self.resultFileName]
                        //   : res.data
                        let data
                        try {
                          data = JSON.parse(res.data)
                          data = data.data
                        } catch (e) {
                          data = {}
                        }
                        const target = data && data.path
                        resolve(target)
                      } else {
                        reject('fail to upload image:' + remoteUrlIndex)
                      }
                    },
                    fail: function (res) {
                      reject('fail to upload image:' + remoteUrlIndex)
                    }
                  })
                })
              )
            }
            Promise.all(promiseWorkList).then(result => {
              if (_self.isDestroyed) {
                return
              }
              for (let i = 0; i < result.length; i++) {
                _self.imageList.push(result[i])
              }

              _self.imageList = _self.imageList.map(file => {
                return outImageFullPath(file)
              })

              _self.$emit('add', {
                currentImages: imagePathArr,
                allImages: _self.imageList
              })
              _self.$emit('update:modelValue', _self.imageList)
            })
          } else {
            for (let i = 0; i < imagePathArr.length; i++) {
              _self.imageList.push(imagePathArr[i])
            }

            _self.imageList = _self.imageList.map(file => {
              return outImageFullPath(file)
            })

            _self.$emit('add', {
              currentImages: imagePathArr,
              allImages: _self.imageList
            })
            _self.$emit('update:modelValue', _self.imageList)
          }
        }
      })
    },
    deleteImage: function (e) {
      var imageIndex = e.currentTarget.dataset.index
      var deletedImagePath = this.imageList[imageIndex]
      this.imageList.splice(imageIndex, 1)

      // this.imageList = this.value
      //检查删除图片的服务器地址是否设置，如果设置则调用API，在服务器端删除该图片
      if (this.serverUrlDeleteImage) {
        uni.request({
          url: this.serverUrlDeleteImage,
          method: 'GET',
          data: {
            imagePath: deletedImagePath
          },
          success: res => {}
        })
      }

      this.$emit('delete', {
        currentImage: deletedImagePath,
        allImages: this.imageList
      })
      this.$emit('update:modelValue', this.imageList)
    },
    previewImage: function (e) {
      var imageIndex = e.currentTarget.dataset.index

      uni.previewImage({
        current: imageIndex,
        urls: this.imageList
      })
    },
    initImageBasePos: function () {
      const paddingRate = 0.024
      var _self = this
      //计算图片基准位置
      // uni.getSystemInfo({
      //   success: function (obj) {
      //     const screenWidth = obj.screenWidth
      //     const leftPadding = Math.ceil(paddingRate * screenWidth)
      //     const imageWidth = Math.ceil((screenWidth - 2 * leftPadding) / 4)

      //     _self.imageBasePos.x0 = leftPadding
      //     _self.imageBasePos.w = imageWidth
      //     _self.imageBasePos.h = imageWidth
      //   }
      // })
    },
    findOverlapImage: function (posX, posY) {
      const rows = Math.floor((posX - this.imageBasePos.x0) / this.imageBasePos.w)
      const cols = Math.floor((posY - this.imageBasePos.y0) / this.imageBasePos.h)
      const indx = cols * 4 + rows
      return indx
    },
    isDragging: function (indx) {
      return this.dragIndex === indx
    },
    start: function (e) {
      if (!this.isDragable) {
        return
      }
      this.dragIndex = e.currentTarget.dataset.index
      this.moveImagePath = this.imageList[this.dragIndex]
      this.showMoveImage = true

      //计算纵向图片基准位置
      if (this.imageBasePos.y0 === -1) {
        this.initImageBasePos()

        const basePosY = Math.floor(this.dragIndex / 4) * this.imageBasePos.h
        const currentImageOffsetTop = e.currentTarget.offsetTop
        this.imageBasePos.y0 = currentImageOffsetTop - basePosY
      }

      //设置选中图片当前左上角的坐标
      this.moveLeft = e.target.offsetLeft
      this.moveTop = e.target.offsetTop
    },
    move: function (e) {
      if (!this.isDragable) {
        return
      }
      const touch = e.touches[0]
      this.targetImageIndex = this.findOverlapImage(touch.clientX, touch.clientY)

      //初始化deltaLeft/deltaTop
      if (this.deltaLeft === 0) {
        this.deltaLeft = touch.clientX - this.moveLeft
        this.deltaTop = touch.clientY - this.moveTop
      }

      //设置移动图片位置
      this.moveLeft = touch.clientX - this.deltaLeft
      this.moveTop = touch.clientY - this.deltaTop
    },
    stop: function (e) {
      if (!this.isDragable) {
        return
      }
      if (this.dragIndex !== null && this.targetImageIndex !== null) {
        if (this.targetImageIndex < 0) {
          this.targetImageIndex = 0
        }

        if (this.targetImageIndex >= this.imageList.length) {
          this.targetImageIndex = this.imageList.length - 1
        }
        //交换图片
        if (this.dragIndex !== this.targetImageIndex) {
          this.imageList[this.dragIndex] = this.imageList[this.targetImageIndex]
          this.imageList[this.targetImageIndex] = this.moveImagePath
        }
      }

      this.dragIndex = null
      this.targetImageIndex = null
      this.deltaLeft = 0
      this.deltaTop = 0
      this.showMoveImage = false

      this.$emit('update:modelValue', this.imageList)
    }
  }
}
</script>

<style lang="scss">
.imageUploadContainer {
  padding: 0.213333rem 0.106667rem;
  margin: 0.213333rem 0.106667rem;
}

.dragging {
  transform: scale(1.2);
}

.imageUploadList {
  display: flex;
  flex-wrap: wrap;
}

.imageUpload {
  width: 3.2rem;
  height: 3.2rem;
  margin: 0.213333rem;
}
.imageItem {
  width: 3.2rem;
  height: 3.2rem;
  margin: 0.213333rem;
  .img {
    width: 3.2rem;
    height: 3.2rem;
  }
}
.imageDel {
  margin-top: -0.746667rem;
  margin-left: -0.213333rem;
  position: relative;
  bottom: 100%;
  left: 100%;
  // left: 2.688rem;
  // bottom: 3.754667rem;
  background-color: rgba(0, 0, 0, 0.5);
  width: 0.768rem;
  text-align: center;
  line-height: 0.746667rem;
  border-radius: 0.362667rem;
  color: white;
  font-size: 0.64rem;
  padding-bottom: 0.042667rem;
}

.imageItem image,
.moveImage {
  width: 3.413333rem;
  height: 3.413333rem;
  border-radius: 0.170667rem;
}

.imageUpload {
  line-height: 2.773333rem;
  text-align: center;
  font-size: 3.2rem;
  color: #d9d9d9;
  border: 0.021333rem solid #d9d9d9;
  border-radius: 0.170667rem;
}

.moveImage {
  position: absolute;
}
</style>
